import ResetPasswordForm from '@/lib/common/components/ResetPasswordForm';
import useTeams from '@/lib/teams/hooks/useTeams';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/auth/create-password')({
    component: RouteComponent,
});

function RouteComponent() {
    const { teams } = useTeams();

    return (
        <div className='max-w-2xl md:mx-auto'>
            <div className='text-center text-2xl'>
                Congrats! You have been invited to Caddy Stats{teams?.length ? ` by ${teams[0].name}.` : '.'}
            </div>
            <ResetPasswordForm create />
        </div>
    );
}
